module.exports = __webpack_public_path__ + "static/img/empty.7d4ec16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/empty.png
// module id = vTAX
// module chunks = 1